/*eslint-disable */

import assignmentSolutionlist from '@/components/assignmentSolutionlist/index'
import uploadsolutionform from '@/components/uploadsolutionform/index'

var $ = window.jQuery = require('jquery');

export default {
  name: 'assignmentbrief',
  components: {
    'assignment-solution': assignmentSolutionlist,
    uploadsolutionform
    
  },
  props: [],
  data () {
    return {
      assignmentBrief: {},
      accordionVal: 0
    }
  },
  computed: {
    getAssignmentBrief(){
      this.assignmentBrief =  this.$store.state.assignmentStore.singleAssignmentState;
      return this.assignmentBrief;
    }
  },
  mounted () {
    this.getAssignmentBrief;
    // $(document).ready(function() {
    //   $('.accordion .accordion-title').on('click', function(){
    //     $(this).siblings('.accordion-content').toggleClass('show');
    //   })
    //  })
  },
  methods: {
    showAccordion(id){
      //this.accordionVal = id;
      let accordionContent = '#accordioncontent' + id;
      let accordionTitle = '#accordiontitle' + id;
      $(accordionContent).toggleClass('show');
      $(accordionTitle).toggleClass('active');
    },
    checkFileExtension(file){
      let extension = file.substr( (file.lastIndexOf('.') +1) );
        switch(extension) {
            case 'jpg':
              return require('./../../../assets/images/filetype/jpg.png')
              break;
            case 'jpeg':
              return require('./../../../assets/images/filetype/jpg.png')
              break;
            case 'png':
              return require('./../../../assets/images/filetype/png.png')
              break;
            case 'gif':
              return require('./../../../assets/images/filetype/jpg.png')
              break;
            case 'zip':
              return require('./../../../assets/images/filetype/zip.png')
              break;
            case 'rar':
              return require('./../../../assets/images/filetype/zip-1.png');
              break;
            break;
            case 'eps':
              return require('./../../../assets/images/filetype/ai.png')
              break;
            case 'pdf':
              return require('./../../../assets/images/filetype/pdf.png')
              break;
            case 'css':
              return require('./../../../assets/images/filetype/css.png')
              break;
            case 'csv':
              return require('./../../../assets/images/filetype/csv.png')
              break;
            case 'doc':
              return require('./../../../assets/images/filetype/doc.png')
              break;
            case 'docx':
              return require('./../../../assets/images/filetype/doc.png')
              break;
            case 'json':
              return require('./../../../assets/images/filetype/json-file.png')
              break;
            case 'ppt':
              return require('./../../../assets/images/filetype/ppt.png')
              break;
            case 'pptx':
              return require('./../../../assets/images/filetype/ppt.png')
              break;
            case 'txt':
              return require('./../../../assets/images/filetype/txt.png')
              break;
            case 'xls':
              return require('./../../../assets/images/filetype/xls.png')
              break;
            case 'xml':
              return require('./../../../assets/images/filetype/xml.png')
              break;
            default:
              return require('./../../../assets/images/filetype/search.png')
              
        } 
  }
  },
  watch: {
    getAssignmentBrief(){
    //  console.log(this.$store.getters.singleAssignment);
     // debugger;
      return  this.$store.state.assignmentStore.singleAssignmentState;
    }
  }
}
